export const COMMERCIAL_URLS = {
  hub: "/commercial",
  compliance: "/commercial-compliance",
  socialValue: "/commercial-social-value",
  caseStudies: "/commercial-case-studies",
  forTrade: "/for-trade",
} as const;

export type CommercialLinkKey = keyof typeof COMMERCIAL_URLS;

export const COMMERCIAL_LINK_LABELS: Record<
  "compliance" | "socialValue" | "caseStudies",
  string
> = {
  compliance: "Compliance & accreditations",
  socialValue: "Social value reporting",
  caseStudies: "Case studies",
};
